import { render, staticRenderFns } from "./TabelaDeItensDeItem.vue?vue&type=template&id=fd7f0b12&scoped=true"
import script from "./TabelaDeItensDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeItensDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeItensDeItem.vue?vue&type=style&index=0&id=fd7f0b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7f0b12",
  null
  
)

export default component.exports